var store = {
    debug: true,
    state: {
        section: 'home',
        previousSection: null
    },
    client: {
        name: null,
        email: null,
        sellername: null,
        sellerkvk: null,
        targetname: null,
        targetkvk: null,
        termsAndConditions: true
    },
    answers: [],
    // chapters: [],

    setSection(section) {
        this.state.previousSection = this.state.section;
        this.state.section = section;
    },

    setSectionWithPreviousSection(section, previousSection) {
        this.state.previousSection = previousSection;
        this.state.section = section;
    }
}

export default store;
